import {
  BEGIN_FEATURE_FLAG_FETCH,
  END_FEATURE_FLAG_FETCH,
  UPDATE_BULK_FEATURE_FLAG_VALUES,
  UPDATE_FEATURE_FLAG_VALUE,
} from '../constants/actions';

export const updateFeatureFlagValue = (flag, value) => {
  return {
    type: UPDATE_FEATURE_FLAG_VALUE,
    flag,
    value,
  };
};

/*
 *
 * expects format of:
 * [ { flag: ‘grow-act-clarify-trial’,
 *   resultDetails: { result: ‘show-new’, ineligible: false } } ]
 *
 */

export const updateBulkFeatureFlagValues = flags => {
  const flagsObj = flags.reduce(
    (flagAcc, { flag, resultDetails: { result } }) => ({
      ...flagAcc,
      [flag]: {
        fetching: false,
        fetched: true,
        key: flag,
        value: result,
      },
    }),
    {}
  );

  return {
    type: UPDATE_BULK_FEATURE_FLAG_VALUES,
    flagsObj,
  };
};

export const beginFeatureFlagFetch = flag => {
  return {
    type: BEGIN_FEATURE_FLAG_FETCH,
    flag,
  };
};

export const endFeatureFlagFetch = flag => {
  return {
    type: END_FEATURE_FLAG_FETCH,
    flag,
  };
};
